import React from 'react';
import PageLayout from '../components/templates/PageLayout';
import HeroSection from '../components/organisms/HeroSection';
import ProofStrip from '../components/organisms/ProofStrip';
import MethodologySection from '../components/organisms/MethodologySection';
import TestimonialSection from '../components/organisms/TestimonialSection';
import AudienceBand from '../components/organisms/AudienceBand';
import NewsSection from '../components/organisms/NewsSection';
import PhotoGallery from '../components/molecules/PhotoGallery';
import YouTubeAutoplay from '../components/organisms/YouTubeAutoplay';
import LinkButton from '../components/atoms/LinkButton';
import LazyImage from '../components/atoms/LazyImage';
import { activeOffer } from '../data/activeOffer';
import { homeMethodology } from '../data/methodology';
import { getTestimonialsByIds, homeTestimonialIds } from '../data/testimonials';
import { getPartnersByIds, homePartnerIds } from '../data/partners';
import { getNewsByIds, homeNewsIds } from '../data/newsItems';
import { homeGalleryPhotos } from '../data/homeGalleryPhotos';

const Home = () => {
  const curatedTestimonials = getTestimonialsByIds(homeTestimonialIds);
  const curatedPartners = getPartnersByIds(homePartnerIds);
  const curatedNews = getNewsByIds(homeNewsIds);

  return (
    <PageLayout>
      <HeroSection />
      <ProofStrip />
      <MethodologySection
        id={homeMethodology.id}
        title={homeMethodology.title}
        subtitle={homeMethodology.subtitle}
        steps={homeMethodology.steps}
      />
      <TestimonialSection
        title="What schools and families say"
        items={curatedTestimonials}
        showStars={false}
      />
      <AudienceBand />
      <section className="py-16 md:py-20 bg-gray-100">
        <div className="dr-container">
          <h2 className="text-3xl md:text-4xl font-black mb-4 text-center text-navy">
            Trusted By
          </h2>
          <p className="text-center mb-10 max-w-prose mx-auto text-gray-700">
            We&apos;re proud to collaborate with these outstanding organizations to bring
            innovative STEM education to youth through sports.
          </p>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 items-center">
            {curatedPartners.map((partner) => (
              <div key={partner.id} className="flex items-center justify-center">
                <a
                  href={partner.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="transition-opacity duration-150 hover:opacity-80 focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow focus-visible:ring-offset-2 rounded-sm motion-reduce:transition-none"
                >
                  <LazyImage
                    src={partner.logo}
                    alt={partner.name}
                    className="max-h-24 max-w-full object-contain"
                    loading="lazy"
                  />
                </a>
              </div>
            ))}
          </div>
          <div className="text-center mt-12">
            <LinkButton to="/partners" className="text-lg py-3 px-6">
              View All Partners &amp; Support Initiatives
            </LinkButton>
          </div>
        </div>
      </section>
      <NewsSection items={curatedNews} limit={3} />
      <section className="py-16 md:py-20 bg-white">
        <div className="dr-container">
          <h2 className="text-3xl md:text-4xl font-black mb-4 text-center text-navy">
            See footyLab in Action
          </h2>
          <p className="text-lg text-gray-600 text-center mb-12 max-w-prose mx-auto">
            Experience the excitement and learning that happens in our programs through
            these moments captured during our sessions.
          </p>
          <PhotoGallery photos={homeGalleryPhotos} />
        </div>
      </section>
      <YouTubeAutoplay
        videoId="6eH8po7p35c"
        title="DataRook Summer Camp 2025 Highlights"
      />
      <section className="py-16 md:py-20 bg-navy text-white">
        <div className="dr-container text-center">
          <h2 className="text-3xl md:text-4xl font-black mb-4 text-yellow">
            Upcoming programs
          </h2>
          <p className="text-lg md:text-xl mb-4 max-w-prose mx-auto text-white/95">
            Express interest in future footyLab sessions. {activeOffer.nextStep}
          </p>
          <LinkButton to={activeOffer.destination} variant="primary" className="text-lg py-3 px-6">
            {activeOffer.label}
          </LinkButton>
        </div>
      </section>
    </PageLayout>
  );
};

export default Home;
